import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import {
  refreshAuthSession,
  getPostLoginPath,
  isPathAllowedForSession
} from '../services/authService';
import { AuthSessionProvider } from '../contexts/AuthSessionContext';

function ProtectedRoute({ children }) {
  const location = useLocation();
  const [status, setStatus] = useState('loading'); // loading | ready | guest
  const [session, setSession] = useState(null);

  useEffect(() => {
    let cancelled = false;

    (async () => {
      const next = await refreshAuthSession();
      if (cancelled) return;
      if (!next) {
        setSession(null);
        setStatus('guest');
        return;
      }
      setSession(next);
      setStatus('ready');
    })();

    return () => {
      cancelled = true;
    };
  }, [location.pathname]);

  if (status === 'loading') {
    return (
      <div className="auth-boot" style={{ padding: '2rem', textAlign: 'center' }}>
        Checking session…
      </div>
    );
  }

  if (status === 'guest' || !session) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  if (!isPathAllowedForSession(session, location.pathname)) {
    return <Navigate to={getPostLoginPath(session)} replace />;
  }

  return <AuthSessionProvider session={session}>{children}</AuthSessionProvider>;
}

export default ProtectedRoute;
